<template>
    <div class="market-GCBR-index">
      <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
        <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
      </Search>
      <div class="fun-btn-box">
      </div>
      <Table
        :tableThData="tableThData"
        :tableTrData="tableTrData"
        :loading="loading"
        :limit="limit"
        :total="total"
        :offset="offset"
        v-on:handleSizeChange="handleSizeChange"
        v-on:handleCurrentChange="handleCurrentChange"
      >
        <template #id="{ row }">{{ row.id }}</template>
        <template #settlementNo="{ row }">{{ row.settlementNo }}</template>
        <template #settlementTime="{ row }">{{ row.settlementTime ? $moment(row.settlementTime).format('YYYY/MM/DD') : '' }}</template>
        <template #mallName="{ row }">{{ row.mallName }}</template>
        <template #storeName="{ row }">{{ row.storeName}}</template>
        <template #joinNetWork="{ row }">{{ row.joinNetWork}}</template>
        <template #netTrading="{ row }">{{ row.netTrading}}</template>
        <template #transactionFee="{ row }">{{ row.transactionFee }}</template>
        <template #receivableTotal="{ row }">{{ row.receivableTotal }}</template>
        <template #withdrawal="{ row }">{{ row.withdrawal }}</template>
        <template #receivedAmount="{ row }">{{ row.receivedAmount}}</template>
        <template #withdrawalStatus="{ row }">{{ row.withdrawalStatus}}</template>
        <template #operation="{ scope }">
        <auth-button auth="refundapply:update">
          <el-button v-if="scope.row.withdrawalStatus == '未提现'" type="text" @click="onAgree(scope.row)" class="mr10">手动分账</el-button>
        </auth-button>
      </template>
      </Table>
    </div>
  </template>
  
  <script>
  import AuthButton from '@/components/AuthButton'
  import tableList from '@/mixins/tableList'
  import { downFile } from "@/utils";
  import {api_getStoreFinancialDetailList,api_postStoreFinancialDetailExport,api_getStatement,api_putSeparateAccounts,api_postSettlementExport} from '@/api/finance'
  import Search from "@/components/Search/index";
  import Table from "@/components/Table/index";
  export default {
    name: "mcheckGCBRIndex",
    mixins: [ tableList ],
    components: {
      AuthButton,
      Search,
      Table,
    },
    data() {
      return {
        renderData: [
          {
            label: "选择日期",
            placeholder: ['开始时间', '结束时间'],
            type: "date-range",
            key: "created",
          },
          {
            label: "店铺名称",
            type: "choose-store",
            key: "storeId",
          },
          {
            label: "商场名称",
            placeholder: '请选择商场名称',
            type: "mall",
            key: "mallId",
          }
          
        ],
        form: {},
        tableKey: false,
        exportLoading: false,
        tableThData: [
          { prop: "id", label: "ID", minWidth: "100", },
          { prop: "settlementNo", label: "结算单号", minWidth: "200", },
          { prop: "settlementTime", label: "结算日期", minWidth: "180", },
          { prop: "mallName", label: "商场名称", minWidth: "180", },
           { prop: "storeName", label: "店铺名称", minWidth: "180", },
           { prop: "joinNetWork", label: "入网状态", minWidth: "180", },
          { prop: "netTrading", label: "核销总额(元)", minWidth: "150", },
          { prop: "transactionFee", label: "交易手续费(元)", minWidth: "150", },
          { prop: "receivableTotal", label: "提现总额(元)", minWidth: "150", },
          { prop: "withdrawal", label: "提现手续费(元)", minWidth: "150", },
          { prop: "receivedAmount", label: "实付提现金额(元)", minWidth: "180", },
          { prop: "withdrawalStatus", label: "提现状态", minWidth: "180", },  
          { prop: "operation", label: "操作", minWidth: "100", },
        ]
      };
    },
    created () {
      this.getList()
    },
    methods: {
      // 获取表格列表数据
      async getList () {
        this.loading = true
        const params = {
          ...this.form,
          offset: this.offset,
          limit: this.limit,
        }
        this.$router.push({query: params})
        let newParams = {...params}
        if(newParams.created && newParams.created.length > 0){
          newParams.startTime = +new Date(newParams.created[0])
          newParams.endTime = +new Date(newParams.created[1])
        }
        delete newParams.created
        const data = await api_getStatement(newParams)
        this.tableTrData = data.data.list || []
        this.total = data.data.count
        this.loading = false
        console.log("DATA:",data.data.count)
      },
      //导出
       async onExport() {
        this.exportLoading = true
        let params = {
          mallId: this.form.mallId || [],
          storeId: this.form.storeId || [],
        }
        if(this.form.created && this.form.created.length > 0){
          params.startTime = +new Date(this.form.created[0])
          params.endTime = +new Date(this.form.created[1])
        }
        let res = await api_postSettlementExport(params) // 结算明细 （列表）
        downFile(res) // 导出结算明细
        this.exportLoading = false
      },
      //手动结算
      onAgree(row) {
      this.$baseConfirm(
        '是否手动结算？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          // let params = {
          //   paymentOrderId: row.paymentOrderId,
          //   id: row.id,
          //   status: 'Approved',
          // }
          await api_putSeparateAccounts(row.storeId,row.id)
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },
    },
    watch: {
    },
    computed: {},
  };
  </script>
  <style lang="scss" scoped>
  .market-GCBR-index {
    width: 100%;
    box-sizing: border-box;
  
    .fun-btn-box {
      margin-top: 20px;
    }
  
    .look-phone-btn {
      font-size: 10px;
      color: #3775FF;
      margin-left: 5px;
    }
  
    .del {
      color: #F74A4A;
    }
    .status{
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      vertical-align: middle;
    }
    .dot-success{
      background: #05c8af;
    }
  
    .dot-clear {
      background: #F74A4A;
    }
  
    .dot-ing {
      background: #3775FF;
    }
  
    .dot-new {
      background: #ccc;
    }
  }
  </style>